export default "__VITE_ASSET__CnsNUwVu__"